import { render, staticRenderFns } from "./newFactoryLabel.vue?vue&type=template&id=5a2d7ee1&scoped=true"
import script from "./newFactoryLabel.vue?vue&type=script&lang=js"
export * from "./newFactoryLabel.vue?vue&type=script&lang=js"
import style0 from "./newFactoryLabel.vue?vue&type=style&index=0&id=5a2d7ee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d7ee1",
  null
  
)

export default component.exports